export const SET_ANSWER = "setAnswer";
export const SET_QUESTION_FORWARD = "setQuestionForward";
export const SET_QUESTION_BACKWARD = "setQuestionBackward";
export const RESET_QUESTIONS = "resetQuestions";

export const LOADING_START = "loadingStart";
export const LOADING_END = "loadingEnd";

export const SET_SETTINGS = "setSettings";
export const SET_PRODUCTS = "setProducts";

export const SET_FINANCE_PERIOD = "setFinancePeriod";

export const SET_SELECTED_PRODUCT_PACK = "setSelectedProductPack";

export const SET_CUSTOMER_DETAILS = "setCustomerDetails";

export const SET_ADDRESSES = "setAddresses";
export const SET_ADDRESS = "setAddress";
export const SET_POSTCODE = "setPostcode";

export const SET_QUESTIONS_COMPLETE = "setQuestionsComplete";
export const SET_CUSTOMER_DETAILS_COMPLETE = "setCustomerDetailsComplete";

export const SET_QUOTE_COMPLETE = "setQuoteComplete";

export const RESET_QUOTE_VARS = "resetQuoteVars";